import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { directoryListSearchSchema } from '@/features/admin/roles/hooks/use-directory-pagination';
import { UsersRolesPage } from '@/features/admin/roles/UsersRolesPage';

export const Route = createFileRoute('/_protected/t/$tenantId/admin/roles/users')({
  component: UsersRolesPage,
  validateSearch: directoryListSearchSchema.extend({
    email: z.string().optional(),
  }),
});
